module.exports = __webpack_public_path__ + "assets/img/Type E (57).d9df0d3c.jpg";